// extracted by mini-css-extract-plugin
module.exports = {"container":"ProductPerks_container__xovRl","variantWrapper":"ProductPerks_variantWrapper__aD85E","variantMoreText":"ProductPerks_variantMoreText__l3O7E"};